import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "@/shared/api/axios";
import { getWorkspaceNameFromUrl } from "@/entities/WorkSpace/api/getWorkspaceId";

interface WorkspaceState {
  workspaceData: {
    korName: string;
    bizNumber: string;
  } | null;
  primaryCompany: {
    korName: string;
    bizNumber: string;
    companyId: string;
  } | null;
  companies: {
    korName: string;
    bizNumber: string;
    companyId: string;
    primary: boolean;
  }[];
}

const initialState: WorkspaceState = {
  workspaceData: null,
  primaryCompany: null,
  companies: []
};

export const layoutHeaderSlice = createSlice({
  name: "layoutHeader",
  initialState,
  reducers: {
    setPrimaryCompany: (state, action) => {
      state.primaryCompany = action.payload;
      state.workspaceData = {
        korName: action.payload.korName,
        bizNumber: action.payload.bizNumber
      };
    },
    setCompanies: (state, action) => {
      // isDeleted가 true인 회사들은 제외
      const activeCompanies = action.payload.filter((company: any) => !company.isDeleted);
      state.companies = activeCompanies;
      // primary 회사 찾아서 설정
      const primaryCompany = activeCompanies.find((company: any) => company.primary);
      if (primaryCompany) {
        state.primaryCompany = primaryCompany;
        state.workspaceData = {
          korName: primaryCompany.korName,
          bizNumber: primaryCompany.bizNumber
        };
      }
    },
    updateCompanyInList: (state, action) => {
      const company = state.companies.find(c => c.companyId === action.payload.companyId);
      if (company) {
        company.korName = action.payload.korName;
        company.bizNumber = action.payload.bizNumber;
        
        // primary 회사인 경우에만 헤더 정보 업데이트
        if (company.primary) {
          state.primaryCompany = {
            korName: action.payload.korName,
            bizNumber: action.payload.bizNumber,
            companyId: action.payload.companyId
          };
          state.workspaceData = {
            korName: action.payload.korName,
            bizNumber: action.payload.bizNumber
          };
        }
      }
    }
  }
});

// Thunk 액션 생성
export const fetchWorkspaceData = () => async (dispatch: any) => {
  try {
    const response = await axios.get(`/v1/hub/workspaces/${getWorkspaceNameFromUrl()}`);
    dispatch(setPrimaryCompany(response.data.data.primaryCompany));
  } catch (error) {
    console.error('워크스페이스 데이터를 불러오는데 실패했습니다:', error);
  }
};

export const { setPrimaryCompany, setCompanies, updateCompanyInList } = layoutHeaderSlice.actions;